var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2"},[_c('renderer',{ref:"renderer",attrs:{"schema":_vm.template.schema},on:{"input":_vm.handleResult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }